module.exports = __webpack_public_path__ + "img/ID.bb3ad52c.webp";